// @ts-ignore
import { S3StreamLogger } from 's3-streamlogger'
import { BluesnapCallbackData, BluesnapCreditCard, Campaign } from 'Types/index'

export const s3stream = new S3StreamLogger({
  bucket: 'sound-server-logs',
  access_key_id: 'AKIA3CZRSX2T3RSSAIAU',
  secret_access_key: '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',
  config: {
    region: 'eu-central-1',
  },
})

export const sendLogsToS3 = (
  amount: number | string,
  transactionBalance: number | string,
  balanceUsedThisTime: number | string,
  campaign: Campaign,
  callback: BluesnapCallbackData,
  type: string,
  creditCard: BluesnapCreditCard
) => {
  const now_date = new Date().toISOString()

  if (type !== 'shopper - 3DS') {
    s3stream.write(
      `${now_date}, Bluesnap payment,
        ${type},
        amount - ${amount},
        transactionBalance - ${transactionBalance},
        balanceUsedThisTime - ${balanceUsedThisTime},
        campaign_id - ${campaign.id}, 
        card type: ${callback.cardData.ccType}, 
        last 4 digits: ${callback.cardData.last4Digits}, 
        exp: ${callback.cardData.exp}, 
        issuing Country: ${callback.cardData.issuingCountry}, 
        isRegulatedCard: ${callback.cardData.isRegulatedCard}, 
        cardSubType: ${callback.cardData.cardSubType}, 
        binCategory: ${callback.cardData.binCategory},
         ccBin: ${callback.cardData.ccBin},
        3DS result: ${
          callback.threeDSecure != null
            ? callback.threeDSecure.authResult
            : null
        }`
    )
  } else {
    s3stream.write(`${now_date}, Bluesnap payment,
      ${type},
      amount - ${amount},
      transactionBalance - ${transactionBalance},
      balanceUsedThisTime - ${balanceUsedThisTime},
      campaign_id - ${campaign.id},
      card type: ${creditCard.cardType}
      last 4 digits: ${creditCard.cardLastFourDigits}`)
  }
}
